<template>
  <div>
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Domain</th>
        <th>Date</th>
        <th>Price</th>
        <th>TF</th>
        <th>CF</th>
        <th>Links</th>
        <th>Domains</th>
        <th>IPs</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(domain, i) in domains" :key="i">
        <td>
          <input type="checkbox" name="domains[]" :value="domain.domain" :id="'domaincb-' + i" v-if="!domain.ordered">
          <i class="fa fa-clock green" title="Ordered" v-else></i>
          <label :for="'domaincb-' + i" class="m-l-sm">{{ domain.domain }}</label>
        </td>
        <td>{{ $moment(domain.expiry.date).format('DD.MM.') }}</td>
        <td>165 SEK</td>
        <td>{{ domain.stats.tf }}</td>
        <td>{{ domain.stats.cf }}</td>
        <td>{{ domain.stats.links }}</td>
        <td>{{ domain.stats.domains }}</td>
        <td>{{ domain.stats.ips }}</td>
        <td>
          <button class="btn-primary btn-xs btn" v-if="!domain.ordered" @click="orderDomain(domain.domain, i)"><i class="fa fa-cart-plus"></i> Order</button>
          <button class="btn-success btn-xs btn" disabled><i class="fa fa-chart-bar"></i> Request Stats</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      domains: []
    }
  },
  mounted () {
    this.loadDomains()
    document.title = 'Domain Backorders :: PBN360 by Aphex Media'
  },
  methods: {
    loadDomains (date = null) {
      axios.get('/domains')
        .then(r => {
          this.domains = r.data.data
        })
        .catch()
    },
    orderDomain (domain, i) {
      axios.post('/domains/order', {
        domain: domain
      })
        .then(r => {
          this.domains[i].ordered = true
          this.$toastr.success('Status will be updated after the raffle has taken place', 'Domain ordered')
        }).catch(e => {
          this.$toastr.error(e, 'Order Failed')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Domains/DomainsTab.vue